import { teamTypes } from '@constants/team'

export const playerTypes = {
  BUILD_UP: 'build_up',
  BREAK_DOWN: 'break_down',
}

export const playerColors = {
  [teamTypes.A]: {
    [playerTypes.BUILD_UP]: 'pink',
    [playerTypes.BREAK_DOWN]: 'orange',
  },
  [teamTypes.B]: {
    [playerTypes.BUILD_UP]: 'green',
    [playerTypes.BREAK_DOWN]: 'blue',
  },
}
